class PredictiveSearch extends HTMLFormElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.resetButton.addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';

    const isTemplateSearch = this.closest('.template-search');
    if (isTemplateSearch) {
      document.addEventListener('click', this.handleClickOutside.bind(this));
    }
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }
  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  onFocus(event) {
    if (this.closest('.template-search')) {
      document.body.classList.add('predictive-search-open');
      if (this.getQuery().length === 0) {
        return;
      }
      const url = this.setupURL().toString();
      this.renderSection(url, event);
    }
  }
  getQuery() {
    return this.input.value.trim();
  }
  clear(event = null) {
    event && event.preventDefault();
    if (this.searchRecommendationEmpty && this.searchContent) {
      this.searchContent.classList.add('hidden');
    }
    /* 16-10: lopende aanvraag afbreken en oude resultaten weghalen, zodat na
       wissen niets van de vorige zoekterm blijft staan. */
    this.bilHuidig = null;
    if (this.bilAfbreken) this.bilAfbreken.abort();
    const resultaten = document.getElementById('PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this));
    if (resultaten) resultaten.innerHTML = '';
    this.removeAttribute('loading');
    this.removeAttribute('error');
    this.resetButton.classList.remove('btn--loading');
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
  }

  setupURL() {
    const url = new URL(`${FoxTheme.routes.shop_url}${FoxTheme.routes.predictive_search_url}`);
    return (
      url.searchParams.set('q', this.getQuery()),
      url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
      url.searchParams.set('resources[limit_scope]', 'each'),
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this)),
      url
    );
  }

  onChange() {
    if (this.getQuery().length === 0) {
      this.clear();
      return;
    }
    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    /* 16-10: alleen het antwoord op de meest recente zoekterm wordt getoond */
    this.bilHuidig = url;
    if (this.bilAfbreken) this.bilAfbreken.abort();
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.removeAttribute('loading');
    this.removeAttribute('error');
    this.resetButton.classList.remove('btn--loading');
    this.renderSearchResults(responseText), this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    // Indicate that loading has started
    this.setAttribute('loading', 'true');
    this.resetButton.classList.add('btn--loading');

    const afbreken = typeof AbortController !== 'undefined' ? new AbortController() : null;
    this.bilAfbreken = afbreken;
    this.removeAttribute('error');

    fetch(url, afbreken ? { signal: afbreken.signal } : undefined)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((responseText) => {
        // Process and cache the fetched data
        this.cachedMap.set(url, responseText);
        if (url !== this.bilHuidig) return; // verouderd antwoord: alleen bewaren
        this.renderSearchResults(responseText);
      })
      .catch((error) => {
        if (error && error.name === 'AbortError') return;
        if (url !== this.bilHuidig) return;
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
        const tekst = this.dataset.bilFout;
        const resultaten = document.getElementById('PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this));
        if (tekst && resultaten) {
          const melding = document.createElement('p');
          melding.className = 'bil-zoek-fout';
          melding.setAttribute('role', 'alert');
          melding.textContent = tekst;
          resultaten.replaceChildren(melding);
          this.searchContent?.classList.remove('hidden');
        }
      })
      .finally(() => {
        if (url !== this.bilHuidig) return;
        // Remove the loading attribute in both success and error cases
        this.removeAttribute('loading');
        this.resetButton.classList.remove('btn--loading');
        this.setAttribute('results', 'true');
      });
  }
  renderSearchResults(responseText) {
    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      const contentElement = parsedDoc.getElementById(id);

      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;
      } else {
        console.error(`Element with id '${id}' not found in the parsed response.`);
      }
    } else {
      console.error(`Element with id '${id}' not found in the document.`);
    }
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      setTimeout(() => {
        document.body.classList.remove('predictive-search-open');
      });
    }
  }
}
customElements.define('predictive-search', PredictiveSearch, { extends: 'form' });

class SearchDrawer extends DrawerComponent {
  constructor() {
    super();
  }
  get requiresBodyAppended() {
    return false;
  }
  get input() {
    return this.querySelector('input[type="search"]');
  }
  get focusElement() {
    return this.querySelector('input[type="search"]');
  }
}
customElements.define('search-drawer', SearchDrawer);
